"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnHeader = function ColumnHeader(_ref) {
  var column = _ref.column,
      label = _ref.label,
      headerClassName = _ref.headerClassName;
  var align = column.align;
  var className = (0, _classnames.default)('text-white text-bold whitespace-nowrap', 'p-2', "text-".concat(align || 'left'), headerClassName);
  return /*#__PURE__*/_react.default.createElement("th", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("b", null, label));
};

ColumnHeader.propTypes = {
  column: _propTypes.default.object.isRequired,
  label: _propTypes.default.string.isRequired,
  headerClassName: _propTypes.default.string
};
var _default = ColumnHeader;
exports.default = _default;